
import { Component, Vue, Prop } from "vue-property-decorator";
import Radio from "./radio.vue";
import RadioText from "./radio-text.vue";
import Checkbox from "./checkbox.vue";
import CheckboxText from "./checkbox-text.vue";
import UnitNumberInput from "./unit-number-input.vue";
import Zifuchuan from "./zifuchuan.vue";
import DsTextarea from "./ds-textarea.vue";
import UnitZifuchuan from "./unit-zifuchuan.vue";
import SingleTime from "./single-time.vue";
import Shuzi from "./shuzi.vue";
@Component({
  components: {
    Radio,
    RadioText,
    Checkbox,
    CheckboxText,
    UnitNumberInput,
    Zifuchuan,
    DsTextarea,
    UnitZifuchuan,
    SingleTime,
    Shuzi,
  },
})
export default class TemplateTransformTwo extends Vue {
  @Prop()
  private index: any;
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  @Prop()
  private level: any;
  private update(val: any) {
    // const data = {
    //   index: this.index,
    //   data: val,
    // };
    // this.$emit("update", data);
  }
  private changeHide(e: any) {
    this.$emit("changeHide", e);
  }
}
